import { Grid, TextField } from '@mui/material';
import { Category } from '@thro-types/leihbar';

import { Field, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

export function CategoryInformation() {
  const { t } = useTranslation();

  const { errors, touched } = useFormikContext<Category>();

  return (
    <Grid container>
      <Grid item xs={12} marginTop={2}>
        <Field
          as={TextField}
          name="name"
          error={touched.name && errors.name}
          helperText={touched.name && errors.name}
          fullWidth
          required
          label={t(translations.pages.leihbar.category.create.name())}
          size="small"
        />
      </Grid>
    </Grid>
  );
}
